/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Cancel_After_No_ExtrasInputs */



/**
* | output |
* | --- |
* | "No external connectors, teams, or API keys" |
*
* @param {Sub_Cancel_After_No_ExtrasInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_cancel_after_no_extras = /** @type {((inputs?: Sub_Cancel_After_No_ExtrasInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Cancel_After_No_ExtrasInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine externen Konnektoren, Teams oder API-Schlüssel")
	return /** @type {LocalizedString} */ ("No external connectors, teams, or API keys")
});